export default ({ adminSettings, feature }) =>
  adminSettings.data?.enabled_social_features?.includes(feature);
